/**
 * Bluebell — hair analyzer rules
 * assets/quiz-rules-hair.js
 *
 * The only file that knows anything about hair. The engine hands in her
 * answers and a small api; this returns the result it should render.
 *
 * Rules, in order of precedence:
 *   1. Chemically treated hair may only ever be given Elone Shampoo.
 *   2. Never more than two shampoos; if two, the copy says to alternate.
 *   3. Rozalia Serum and Elone Cream both sit on the ends, so they alternate.
 *   4. Nothing flagged means maintenance advice and no product.
 *
 * Changing anything here changes the clinical advice customers receive.
 * Treat it like the medical copy it is.
 */
window.QuizRules = window.QuizRules || {};
window.QuizCodes = window.QuizCodes || {};

/* Declared so the engine can warn if the theme blocks drift from these. */
window.QuizCodes.hair = {
  scalp:    ['oily', 'dry', 'normal', 'sensitive'],
  dandruff: ['none', 'mild', 'severe'],
  hairloss: ['none', 'moderate', 'severe'],
  ends:     ['healthy', 'mild', 'damaged'],
  heat:     ['rare', 'sometimes', 'often'],
  texture:  ['none', 'chemical', 'frizzy', 'both']
};

window.QuizRules.hair = function (a, api) {
  var t = api.t;
  var concerns = [];
  var steps = [];
  var reasons = [];
  var shampoos = [];

  function reason(key, vars) {
    reasons.push({ label: t('why.' + key + '_label'), text: t('why.' + key + '_text', vars) });
  }

  function step(key, productKey, vars) {
    var p = productKey ? api.product(productKey) : { url: '', variant: '' };
    return {
      title: t('step.' + key + '_title'),
      text: t('step.' + key + '_text', vars),
      freq: t('step.' + key + '_freq'),
      url: p.url,
      variant: p.variant
    };
  }

  function addShampoo(name, key, productKey) {
    if (shampoos.length >= 2) return false;
    var s = step(key, productKey);
    s.shampooName = name;
    steps.push(s);
    shampoos.push(s);
    return true;
  }

  var isChemical = a.texture === 'chemical' || a.texture === 'both';
  var eloneShampooAdded = false;

  if (isChemical) {
    addShampoo('Elone', 'eloneShampooAlways', 'Elone Shampoo');
    eloneShampooAdded = true;
    reason('chemicalOnlyShampoo');
  }

  if (a.dandruff === 'mild') {
    concerns.push(t('concern.mildDandruff'));
    if (isChemical) {
      reason('mildDandruffChemical');
      steps.push({
        title: t('step.choiceTitle'),
        text: t('step.choiceMild', {
          dago: api.link('Dago', 'Dago'),
          elone: api.link('Elone Shampoo', 'Elone')
        }),
        freq: t('step.choiceFreq'), url: '', variant: ''
      });
    } else {
      reason('mildDandruff');
      addShampoo('Dago', 'dago', 'Dago');
    }
  } else if (a.dandruff === 'severe') {
    concerns.push(t('concern.severeDandruff'));
    if (isChemical) {
      reason('severeDandruffChemical');
      steps.push({
        title: t('step.choiceTitle'),
        text: t('step.choiceSevere', {
          dagoplus: api.link('Dago Plus', 'Dago Plus'),
          elone: api.link('Elone Shampoo', 'Elone')
        }),
        freq: t('step.choiceFreq'), url: '', variant: ''
      });
    } else {
      reason('severeDandruff');
      addShampoo('Dago Plus', 'dagoPlus', 'Dago Plus');
    }
  }

  var serumStep = null;
  var creamStep = null;

  if (a.hairloss === 'moderate') {
    concerns.push(t('concern.moderateLoss'));
    if (isChemical) {
      reason('moderateLossChemical');
    } else {
      reason('moderateLoss');
      addShampoo('Rozalia', 'rozaliaShampoo', 'Rozalia Shampoo');
    }
    steps.push(step('rozaliaLotion', 'Rozalia Lotion'));
    if (isChemical) {
      creamStep = step('eloneCreamInstead', 'Elone Cream');
      steps.push(creamStep);
    } else {
      serumStep = step('rozaliaSerum', 'Rozalia Serum');
      steps.push(serumStep);
    }
  } else if (a.hairloss === 'severe') {
    concerns.push(t('concern.severeLoss'));
    reason('severeLoss');
    steps.push(step('bioxee', 'Bioxee'));
  }

  if (a.ends === 'damaged') {
    concerns.push(t('concern.damagedEnds'));
    reason('damagedEnds');
    var gotShampoo = eloneShampooAdded || addShampoo('Elone', 'eloneShampooWash', 'Elone Shampoo');
    steps.push(step('eloneMask', 'Elone Mask'));
    if (!gotShampoo) {
      creamStep = step('eloneCream', 'Elone Cream');
      steps.push(creamStep);
    }
  } else if (a.ends === 'mild') {
    concerns.push(t('concern.mildEnds'));
    reason('mildEnds');
    creamStep = step('eloneCreamStyling', 'Elone Cream');
    steps.push(creamStep);
  }

  var needsConditioner = a.ends === 'healthy' &&
    (a.texture === 'chemical' || a.texture === 'frizzy' || a.texture === 'both' || a.heat === 'often');

  if (needsConditioner) {
    var variantKey = (a.texture === 'frizzy' || a.texture === 'chemical' || a.texture === 'both')
      ? a.texture : 'heat';
    reason('conditioner', { desc: t('cond.desc_' + variantKey) });
    steps.push(step('eloneConditioner', 'Elone Conditioner', { reason: t('cond.reason_' + variantKey) }));
  }

  if (serumStep && creamStep) {
    serumStep.text += t('alt.serum_suffix');
    creamStep.text += t('alt.cream_suffix');
    serumStep.freq = t('alt.serum_freq');
    creamStep.freq = t('alt.cream_freq');
    reason('alternateEnds');
  }

  if (shampoos.length === 2) {
    shampoos[0].text += t('alt.shampoo_suffix', { other: shampoos[1].shampooName });
    shampoos[1].text += t('alt.shampoo_suffix', { other: shampoos[0].shampooName });
    shampoos[0].freq = t('alt.shampoo_freq');
    shampoos[1].freq = t('alt.shampoo_freq');
    reason('alternateShampoos');
  }

  if (concerns.length === 0) {
    concerns.push(t('concern.allGood'));
    reason('allGood');
    steps.push({
      title: t('step.maintenance_title'),
      text: t('step.maintenance_text'),
      freq: t('step.maintenance_freq'),
      url: '', variant: ''
    });
  }

  var scalpText = t('value.scalp_' + a.scalp);
  var summary = t('result.summary', {
    scalp: scalpText,
    scalp_lower: scalpText.toLowerCase(),
    meaning: t('meaning.scalp_' + a.scalp),
    texture: t('meaning.texture_' + a.texture)
  });
  if (a.heat === 'often') summary += t('meaning.heat_often');

  return {
    title: t('result.title', { scalp: scalpText }),
    summary: summary,
    traits: [
      { label: t('trait.scalp'),   value: scalpText },
      { label: t('trait.ends'),    value: t('value.ends_' + a.ends) },
      { label: t('trait.heat'),    value: t('value.heat_' + a.heat) },
      { label: t('trait.texture'), value: t('value.texture_' + a.texture) }
    ],
    concerns: concerns,
    reasons: reasons,
    steps: steps
  };
};
